import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { environment } from '../../../environments/environment';

@Injectable({
  providedIn: 'root',
})
export class ApiService {
  private apiUrl: string = environment.apiUrl;

  constructor(private http: HttpClient) {}

  get<T>(
    url: string,
    options?: {
      params?:
        | HttpParams
        | {
            [param: string]:
              | string
              | number
              | boolean
              | ReadonlyArray<string | number | boolean>;
          };
    },
  ): Promise<T> {
    return new Promise((resolve, reject) => {
      this.http.get<T>(`${this.apiUrl}${url}`, options).subscribe({
        next: (data) => resolve(data),
        error: (error) => reject(error),
      });
    });
  }

  /** Gets a file (such as a PDF) instead of JSON. */
  getBlob(url: string): Promise<Blob> {
    return new Promise((resolve, reject) => {
      this.http.get(`${this.apiUrl}${url}`, { responseType: 'blob' }).subscribe({
        next: (data) => resolve(data),
        error: (error) => reject(error),
      });
    });
  }

  post<T>(url: string, body: any): Promise<T> {
    return new Promise((resolve, reject) => {
      this.http.post<T>(`${this.apiUrl}${url}`, body).subscribe({
        next: (data) => resolve(data),
        error: (error) => reject(error),
      });
    });
  }

  put<T>(url: string, body: any): Promise<T> {
    return new Promise((resolve, reject) => {
      this.http.put<T>(`${this.apiUrl}${url}`, body).subscribe({
        next: (data) => resolve(data),
        error: (error) => reject(error),
      });
    });
  }

  delete<T>(url: string): Promise<T> {
    return new Promise((resolve, reject) => {
      this.http.delete<T>(`${this.apiUrl}${url}`).subscribe({
        next: (data) => resolve(data),
        error: (error) => reject(error),
      });
    });
  }
}
